<div
    class="quill-editor-container"
    [class]="containerClass"
    [class.quill-disabled]="disabled"
    [class.quill-readonly]="readonly"
    [class.safe-rich-text]="safeDisplay"
    [class.emphasize-links]="emphasizeLinks"
>
    <div #quillEditor [class]="editorClass"></div>
    @if (showError) {
    <lucide-icon [img]="CircleAlert" class="w-6 h-6 text-red-600 error-indicator"></lucide-icon>
    }
</div>
